import { createAction, handleActions } from 'redux-actions';

const loadSupplier = createAction("SCREENS/SUPPLIER_VIEW/LOAD_SUPPLIER");
const updateSupplier = createAction("SCREENS/SUPPLIER_VIEW/UPDATE_SUPPLIER");
const clearSupplier = createAction("SCREENS/SUPPLIER_VIEW/CLEAR_SUPPLIER");

const defaultState = null;

const reducer = handleActions(
  {
    [loadSupplier]: (state, action) => action.payload,
    [updateSupplier]: (state, action) => Object.assign({}, state, {...action.payload}),
    [clearSupplier]: () => null
  },
  defaultState
);

export { loadSupplier, updateSupplier, clearSupplier, reducer };
